import React, { useState } from 'react';
import axios from 'axios';
import {  ValueCard, Type, Action } from '../../models/models';
import './PublishDomain.css';
import HeaderComponent from '../../components/HeaderComponent';

interface PublishResult {
    result: number
    message: string;
    parserCheck: string;
    score: number;
  }

const PublishDomain: React.FC = () => {
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [fileChosen, setFileChosen] = useState(false);
    const [fileD, setFile] = useState<File | null>(null);
    const [publishResult, setPublishResult] = useState<PublishResult | null>(null);
    const [typesList, setItems] = useState<Type[]>([{ typeID: 0, typeName: '' }]);
    const [actions, setActions] = useState<Action[]>([{actionID: 0,  actionName: '', actionDescr: '' }]);
    const [valueCard, setvalueCard] = useState<ValueCard>({
        valueCardID: 0,
        modelName: '',
        modelLang: '',
        basicInfo: {
            basicInfoID: 0,
            modelDeveloper: '',
            createDate: '',
            lastUpdated: '',
            version: '',
            license: '',
            contact: '',
            refDoc: '',
            source: ''
        },
        description: {
            descID: 0,
            purpose: '',
            useCase: '',
            category: ''
        },
        modelParams: {
            mdlParamID: 0,
            mdlSubLang: '',
            isModelTyped: false,
            noTypes: 0,
            typeList: [],
            noActions: 0,
            actionList: []
        },
        domainModelFile: {
            domainModelFileID: 0,
            fileName: '',
            fileContent: '',
            domainModel: null
        },
        scoreInfo: {
            temporal: false,
            spatial: false,
            deterministic: false,
            complicatedActions: false,
            contradictPred: false,
            stdLang: false,
            parsable: false,
            scalable: false,
            failPerf: false,
            noSimplifiedActions: 5
        },
        parserCheck: false,
        planner_eval: false,
        realWorldScore: 0,
        ethicalConsideration: ''
    });

    const [collapsedSections, setCollapsedSections] = useState({
        basicInfo: true,
        description: true,
        modelParams: true,
        domainModelFile: true,
        scoreInfo: true,
        generalInfo: true
    });

    const toggleSection = (section: keyof typeof collapsedSections) => {
        setCollapsedSections({
            ...collapsedSections,
            [section]: !collapsedSections[section]
        });
    };


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        let val: any;

        if (type === 'checkbox') {
            val = (e.target as HTMLInputElement).checked;
        }  else if(type === 'radio'){
            val = e.target.value === 'yes'
        } else {
            val = value;
        }

        setvalueCard({
            ...valueCard,
            [name]: val
        });


    };

    const handleNestedChange = (section: string, name: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        const { type, value } = e.target;
        let val: any;

        if (type === 'checkbox') {
            val = (e.target as HTMLInputElement).checked;
        } else if(type === 'radio'){
            val = e.target.value === 'yes'
        } 
        else {
            val = value;
        }

        setvalueCard({
            ...valueCard,
            [section]: {
                ...valueCard[section],
                [name]: val
            }
        });

    };

    const handleFileChange = (section: string, name: string, file: File | null) => {
        setvalueCard({
            ...valueCard,
            [section]: {
                ...valueCard[section],
                [name]: null
            }
        });

        if(file) {
            setFile(file)
        }
        

        if (file) {
            setFileChosen(true);
        } else {
            setFileChosen(false);
        }
    };
    

    const handleSubmit = async () => {
       // try {
           setvalueCard({
                ...valueCard,
                modelParams: {
                    ...valueCard.modelParams,
                    typeList: typesList
                }
            });
            setvalueCard({
                ...valueCard,
                modelParams: {
                    ...valueCard.modelParams,
                    actionList: actions
                }
            });
            if(valueCard.modelName !== '' && valueCard.modelLang !== '' && valueCard.description.category !== '' && fileD !== null)
            {
            const requestData = new FormData();
            if(fileD){
                requestData.append('domainModelFile', fileD);
            }
            requestData.append('actions', new Blob([JSON.stringify(actions)], { type: 'application/json' }));
            requestData.append('types', new Blob([JSON.stringify(typesList)], { type: 'application/json' }));
            requestData.append('valueCard', new Blob([JSON.stringify(valueCard)], { type: 'application/json' }));

            const response = await axios.post('/api/domain-models/publish', requestData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setPublishResult(response.data as PublishResult);
            setShowPopup(true);
        } else {
            setShowPopup(true);
            setPublishResult(null);
        }
    };

    const handlePopupClose = () => {
        setShowPopup(false);
        if (publishResult && publishResult.result === 0) {
            window.location.href = '/'; // Redirect to homepage
        }
    };

    

    const handleInputChangeType = (index: number, value: string) => {
        const newItems = [...typesList];
        newItems[index].typeID = 0;
        newItems[index].typeName = value;
        setItems(newItems);
    };

    const handleAddType = () => {
        setItems([...typesList, { typeID: 0, typeName: '' }]);
    };

    const handleRemoveLastType = () => {
        if (typesList.length > 1) {
            setItems(typesList.slice(0, -1));
        }
    };

    

    const handleInputChangeAction = (index: number, field: keyof Action, value: string) => {
        const newActions = [...actions];
        newActions[index].actionID = 0;
        newActions[index][field] = value;
        setActions(newActions);
    };

    const handleAddAction = () => {
        setActions([...actions, {actionID: 0,  actionName: '', actionDescr: '' }]);
    };

    const handleRemoveLastAction = () => {
        if (actions.length > 1) {
            setActions(actions.slice(0, -1));
        }
    };

        
    //setIsFormValid(valueCard.modelName !== '' && valueCard.modelLang !== '' && valueCard.description.category !== '' && valueCard.domainModelFile.domainModel !== null);

    return (
        <div>
            <HeaderComponent />
            <div className='head-content'>
                <h1>Publish domain data</h1>            
                <p>Please upload the domain model file and fill in the data for the domain model. Click on + icon to expand sections</p>
            </div>
            <div className='upload-domain'>
                     <div className="form-node">
                        <label htmlFor="domainModel"><h3>Domain model file:<span className="required">*</span></h3></label>
                        <div>
                        <input type="file" name="domainModel" onChange={(e) => handleFileChange('domainModelFile', 'domainModel', e.target.files ? e.target.files[0] : null)} />
                        </div>
                    </div>
            </div>
            <div>
            <h2 className="section" onClick={() => toggleSection('generalInfo')}>
                General {collapsedSections.generalInfo ? '+' : '-'}
            </h2>
            {!collapsedSections.generalInfo && (
                <div>
                    <div className="form-node">
                        <label htmlFor="modelName">Model name:<span className="required">*</span></label>
                        <div>
                        <input type="text" id="modelName" name="modelName" value={valueCard.modelName} onChange={handleChange} placeholder="Model name" />
                        </div>
                    </div>
                    <div className="form-node">
                        <label htmlFor="modelLang">Model language:<span className="required">*</span></label>
                        <div>
                        <select id="modelLang" name="modelLang" value={valueCard.modelLang} onChange={handleChange}>
                            <option value="">Select language</option>
                            <option value="PDDL">PDDL</option>
                            <option value="HPDL">HPDL</option>
                            <option value="HDDL">HDDL</option>
                            <option value="Other">Other</option>
                        </select>
                        </div>
                    </div>
                    <div className="form-node">
                        <label>Is domain model evaluated against a planner?</label>
                        <div>
                            <input type="radio" id="planner_eval_yes" name="planner_eval" value="yes" checked={valueCard.planner_eval === true} onChange={handleChange} />
                            <label htmlFor="planner_eval_yes">Yes</label>
                            <input type="radio" id="planner_eval_no" name="planner_eval" value="no" checked={valueCard.planner_eval === false} onChange={handleChange} />
                            <label htmlFor="planner_eval_no">No</label>
                            <span className="help-icon" title="Has there been testing done using at least one AI Planner on this domain model and a problem">?</span>
                        </div>
                    </div>
                    <div className="form-node">
                        <label htmlFor="ethicalConsideration">Ethical consideration:</label>
                        <div>
                        <textarea id="ethicalConsideration" name="ethicalConsideration" value={valueCard.ethicalConsideration} onChange={handleChange} placeholder="Ethical consideration"></textarea>
                        <span className="help-icon" title="Are there any ethical topics that need to be considered?">?</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
            <div>
                <h2 className= "section" onClick={() => toggleSection('basicInfo')}>
                    Basic information {collapsedSections.basicInfo ? '+' : '-'}
                </h2>
                {!collapsedSections.basicInfo && (
                    <div>
                        <div className="form-node">
                            <label htmlFor="modelDeveloper">Model developer:</label>
                            <div>
                                <input type="text" id="modelDeveloper" name="modelDeveloper" value={valueCard.basicInfo.modelDeveloper} onChange={(e) => handleNestedChange('basicInfo', 'modelDeveloper', e)} placeholder="Model developer" />
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="createDate">Creation date:</label>
                            <div>
                                <input type="date" id="createDate" name="createDate" value={valueCard.basicInfo.createDate} onChange={(e) => handleNestedChange('basicInfo', 'createDate', e)} placeholder="Creation date" />
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="lastUpdated">Last updated:</label>
                            <div>
                                <input type="date" id="lastUpdated" name="lastUpdated" value={valueCard.basicInfo.lastUpdated} onChange={(e) => handleNestedChange('basicInfo', 'lastUpdated', e)} placeholder="Last updated" />
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="version">Model version:</label>
                            <div>
                                <input type="text" id="version" name="version" value={valueCard.basicInfo.version} onChange={(e) => handleNestedChange('basicInfo', 'version', e)} placeholder="Model version" />
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="license">License:</label>
                            <div>
                                <input type="text" id="license" name="license" value={valueCard.basicInfo.license} onChange={(e) => handleNestedChange('basicInfo', 'license', e)} placeholder="License" />
                                <span className="help-icon" title="E.g. MIT License">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="contact">Contact details:</label>
                            <div>
                                <input type="text" id="contact" name="contact" value={valueCard.basicInfo.contact} onChange={(e) => handleNestedChange('basicInfo', 'contact', e)} placeholder="Contact details" />
                                <span className="help-icon" title="Email address or way to reach digitally">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="refDoc">Reference document:</label>
                            <div>
                                <input type="text" id="refDoc" name="refDoc" value={valueCard.basicInfo.refDoc} onChange={(e) => handleNestedChange('basicInfo', 'refDoc', e)} placeholder="Reference document" />
                                <span className="help-icon" title="Related Research documents">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="source">Model source:</label>
                            <div>
                                <input type="text" id="source" name="source" value={valueCard.basicInfo.source} onChange={(e) => handleNestedChange('basicInfo', 'source', e)} placeholder="Model source" />
                                <span className="help-icon" title="Source code location like GitHub, etc.">?</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div>
                <h2 className= "section" onClick={() => toggleSection('description')}>
                    Description {collapsedSections.description ? '+' : '-'}
                </h2>
                {!collapsedSections.description && (
                    <div>
                        <div className="form-node">
                            <label htmlFor="purpose">Purpose:</label>
                            <div>
                            <textarea id="purpose" name="purpose" value={valueCard.description.purpose} onChange={(e) => handleNestedChange('description', 'purpose', e)} placeholder="Purpose"></textarea>
                            <span className="help-icon" title="What purpose does this domain model serve. Example: Airport ground traffic control coordination">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="useCase">Use case:</label>
                            <div>
                            <textarea id="useCase" name="useCase" value={valueCard.description.useCase} onChange={(e) => handleNestedChange('description', 'useCase', e)} placeholder="Use case"></textarea>
                            <span className="help-icon" title="Use cases addressed by domain model. Example: 1. The movements of airplanes are coordinated so that they reach the destination location quickly without collision and without entering unsafe zones">?</span>
                            </div>
                        </div>
                        <div className= "form-node">
                            <label htmlFor="category">Category:<span className="required">*</span></label>
                            <div>
                            <select  id="category" value={valueCard.description.category} onChange={(e) => handleNestedChange('description', 'category', e)}>
                                <option value="">Select Category</option>
                                <option value="Logistics">Logistics</option>
                                <option value="Robotics">Robotics</option>
                                <option value="Space exploration">Space exploration</option>
                                <option value="Healthcare">Healthcare</option>
                                <option value="Game theory">Game theory</option>
                                <option value="Manufacturing">Manufacturing</option>
                                <option value="Smart building">Smart building</option>
                                <option value="Autonomous vehicles">Autonomous vehicles</option>
                                <option value="other">other</option>
                            </select>
                            <span className="help-icon" title="Choose a category that the domain model fits in">?</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div>
                <h2 className= "section" onClick={() => toggleSection('modelParams')}>
                    Model parameters {collapsedSections.modelParams ? '+' : '-'}
                </h2>
                {!collapsedSections.modelParams && (
                    <div>
                        <div className="form-node">
                            <label htmlFor="mdlSubLang">Model sub-language:</label>
                            <div>
                            <input type="text" id="mdlSubLang" name="mdlSubLang" value={valueCard.modelParams.mdlSubLang} onChange={(e) => handleNestedChange('modelParams', 'mdlSubLang', e)} placeholder="Model sub-language" />
                            <span className="help-icon" title="E.g. ADL, STRIPS, etc">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor="isModelTyped">Is model typed?</label>
                            <div>
                                <input 
                                    type="radio" 
                                    id="isModelTypedYes" 
                                    name="isModelTyped" 
                                    value="yes" 
                                    checked={valueCard.modelParams.isModelTyped === true} 
                                    onChange={(e) => handleNestedChange('modelParams', 'isModelTyped', e)} 
                                /> Yes
                                <input 
                                    type="radio" 
                                    id="isModelTypedNo" 
                                    name="isModelTyped" 
                                    value="no" 
                                    checked={valueCard.modelParams.isModelTyped === false} 
                                    onChange={(e) => handleNestedChange('modelParams', 'isModelTyped', e)} 
                                /> No
                            </div>
                        </div>
                        <div className="form-node">                            
                            <label htmlFor="noTypes">Number of types:</label>
                            <div>
                            <input type="number" id="noTypes" name="noTypes" value={valueCard.modelParams.noTypes} onChange={(e) => handleNestedChange('modelParams', 'noTypes', e)} placeholder="Number of types" />
                            </div>
                        </div>
                        <div className="list-node form-node">
                            <label>Type names:</label>
                            <div className="actions-container">
                            {typesList.map((item, index) => (
                                <div key={index}  className='action-item'>
                                    <input
                                        type="text"
                                        placeholder="Type name"
                                        value={item.typeName}
                                        onChange={(e) => handleInputChangeType(index, e.target.value)}
                                    />
                                </div>
                            ))}
                            </div>
                            <label></label>
                            <div>
                            <button onClick={handleAddType}>Add more types</button>
                            <button onClick={handleRemoveLastType}>Remove last type</button>
                            </div>
                            
                        </div>
                        <div className="form-node"> 
                        <label htmlFor="noActions">Number of actions:</label>
                            <div>
                            <input type="number" id="noActions" name="noActions" value={valueCard.modelParams.noActions} onChange={(e) => handleNestedChange('modelParams', 'noActions', e)} placeholder="Number of actions" />
                            </div>
                        </div>
                        <div className="list-node form-node">
                            <label>Actions:</label>
                            <div  className="actions-container">
                            {actions.map((action, index) => (
                                <div key={index} className='action-item'>
                                    <input
                                        type="text"
                                        placeholder="Action name"
                                        value={action.actionName}
                                        onChange={(e) => handleInputChangeAction(index, 'actionName', e.target.value)}
                                    />
                                    <input
                                        type="text"
                                        placeholder="Action description"
                                        value={action.actionDescr}
                                        onChange={(e) => handleInputChangeAction(index, 'actionDescr', e.target.value)}
                                    />
                                </div>
                            ))}
                            </div>
                            <label></label>
                            <div>
                            <button onClick={handleAddAction}>Add more actions</button>
                            <button onClick={handleRemoveLastAction}>Remove last action</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div>
                <h2 className= "section" onClick={() => toggleSection('scoreInfo')}>
                    Score information {collapsedSections.scoreInfo ? '+' : '-'}
                </h2>
                {!collapsedSections.scoreInfo && (
                    <div>
                        <div className="form-node">
                            <label htmlFor='temporal'>Is model temporal? </label>
                            <div>
                            <input type="radio" id="temporal_yes" name="temporal" value="yes" checked={valueCard.scoreInfo.temporal === true} onChange={(e) => handleNestedChange('scoreInfo', 'temporal', e)} />
                            <label htmlFor="temporal_yes">Yes</label>
                            <input type="radio" id="temporal_no" name="temporal" value="no" checked={valueCard.scoreInfo.temporal === false} onChange={(e) => handleNestedChange('scoreInfo', 'temporal', e)} />
                            <label htmlFor="temporal_no">No</label>
                            <span className="help-icon" title="Temporal Models have time specific constraints">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor='spatial'>Is model spatial? </label>
                            <div>
                            <input type="radio" id="spatial_yes" name="spatial" value="yes" checked={valueCard.scoreInfo.spatial === true} onChange={(e) => handleNestedChange('scoreInfo', 'spatial', e)} />
                            <label htmlFor="spatial_yes">Yes</label>
                            <input type="radio" id="spatial_no" name="spatial" value="no" checked={valueCard.scoreInfo.spatial === false} onChange={(e) => handleNestedChange('scoreInfo', 'spatial', e)} />
                            <label htmlFor="spatial_no">No</label>
                            <span className="help-icon" title="Spatial Models have space specific constraints">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor='deterministic'>Is model deterministic? </label>
                            <div>
                            <input type="radio" id="deterministic_yes" name="deterministic" value="yes" checked={valueCard.scoreInfo.deterministic === true} onChange={(e) => handleNestedChange('scoreInfo', 'deterministic', e)} />
                            <label htmlFor="deterministic_yes">Yes</label>
                            <input type="radio" id="deterministic_no" name="deterministic" value="no" checked={valueCard.scoreInfo.deterministic === false} onChange={(e) => handleNestedChange('scoreInfo', 'deterministic', e)} />
                            <label htmlFor="deterministic_no">No</label>
                            <span className="help-icon" title="For a given planner and planning problem, the domain model produces a deterministic flow">?</span>
                            </div>
                        </div>
                        <div className="form-node">
                            <label htmlFor='complicatedActions'>Does model have complicated actions? </label>
                            <div>
                            <input type="radio" id="complicatedActions_yes" name="complicatedActions" value="yes" checked={valueCard.scoreInfo.complicatedActions === true} onChange={(e) => handleNestedChange('scoreInfo', 'complicatedActions', e)} />
                            <label htmlFor="complicatedActions_yes">Yes</label>
                            <input type="radio" id="complicatedActions_no" name="complicatedActions" value="no" checked={valueCard.scoreInfo.complicatedActions === false} onChange={(e) => handleNestedChange('scoreInfo', 'complicatedActions', e)} />
                            <label htmlFor="complicatedActions_no">No</label>
                            <span className="help-icon" title="Complicated actions are actions that have sub actions">?</span>
                            </div>
                        </div>

                        <div className="form-node">
                            <label htmlFor="contradictPred">Does model contain any contradictory predictions?</label>
                            <div>
                                <input type="radio" id="contradictPred_yes" name="contradictPred" value="yes" checked={valueCard.scoreInfo.contradictPred === true} onChange={(e) => handleNestedChange('scoreInfo', 'contradictPred', e)} />
                                <label htmlFor="contradictPred_yes">Yes</label>
                                <input type="radio" id="contradictPred_no" name="contradictPred" value="no" checked={valueCard.scoreInfo.contradictPred === false} onChange={(e) => handleNestedChange('scoreInfo', 'contradictPred', e)} />
                                <label htmlFor="contradictPred_no">No</label>
                                <span className="help-icon" title="Under certain circumstances will any two or more predictions contradict each other">?</span>
                            </div>
                        </div>

                        <div className="form-node">
                            <label htmlFor="scalable">Is model scalable?</label>
                            <div>
                                <input type="radio" id="scalable_yes" name="scalable" value="yes" checked={valueCard.scoreInfo.scalable === true} onChange={(e) => handleNestedChange('scoreInfo', 'scalable', e)} />
                                <label htmlFor="scalable_yes">Yes</label>
                                <input type="radio" id="scalable_no" name="scalable" value="no" checked={valueCard.scoreInfo.scalable === false} onChange={(e) => handleNestedChange('scoreInfo', 'scalable', e)} />
                                <label htmlFor="scalable_no">No</label>
                                <span className="help-icon" title="Does the domain model work for problem statements of any scale?">?</span>
                            </div>
                        </div>

                        <div className="form-node">
                            <label htmlFor="failPerf">Does model provide performance during failure?</label>
                            <div>
                                <input type="radio" id="failPerf_yes" name="failPerf" value="yes" checked={valueCard.scoreInfo.failPerf === true} onChange={(e) => handleNestedChange('scoreInfo', 'failPerf', e)} />
                                <label htmlFor="failPerf_yes">Yes</label>
                                <input type="radio" id="failPerf_no" name="failPerf" value="no" checked={valueCard.scoreInfo.failPerf === false} onChange={(e) => handleNestedChange('scoreInfo', 'failPerf', e)} />
                                <label htmlFor="failPerf_no">No</label>
                                <span className="help-icon" title="E.g. if for Airport control system, what happens if one gate is non-functional due to technical failure? Is the plan still generated?">?</span>
                            </div>
                        </div>
                        <div className= "form-node">
                            <label htmlFor='noSimplifiedActions'>Number of simplified actions: </label>
                            <div>
                            <input type="number" name="noSimplifiedActions" value={valueCard.scoreInfo.noSimplifiedActions} onChange={(e) => handleNestedChange('scoreInfo', 'noSimplifiedActions', e)} placeholder="Number of simplified actions" />
                            <span className="help-icon" title="E.g. Dropping continuos wait criteria for airplanes to take-off OR 
                        ignoring the changes in terrain caused by dust storm for rover moving from point A to B">?</span>
                        </div>
                        </div>
                        
                    </div>   
                )}
            </div>
            <div>
            <div className="form-node">
                <label htmlFor="parserCheck_yes">Publish domain even if parsing fails</label>
                <div>
                    <input type="radio" id="parserCheck_yes" name="parserCheck" value="yes" checked={valueCard.parserCheck === true} onChange={handleChange} />
                    <label htmlFor="parserCheck_yes">Yes</label>
                    <input type="radio" id="parserCheck_no" name="parserCheck" value="no" checked={valueCard.parserCheck === false} onChange={handleChange} />
                    <label htmlFor="parserCheck_no">No</label>
                    <span className="help-icon" title="If this is selected, domain will be published even if parser check fails. You won't be able to resubmit the same domain again. Hint: Only check if model language is other">?</span>
                </div>
            </div>

            </div>
            <div>
                <button className='submit-button' onClick={handleSubmit}>Submit</button>
            </div>
            {showPopup && (
                <div className="popup">
                    <div className="popup-content">
                        {publishResult ? (
                            <>
                                <p>Publish Domain Status: {publishResult.message}</p>
                                <p>Parser Check: {publishResult.parserCheck}</p>
                                <p>Score*: {publishResult.score}</p>
                                <p>* incase of failed/unsuccessful publish status, score is a prediction only and not final</p>
                            </>
                        ) : (
                            <>
                                <p>Required fields incomplete</p>
                                <p>Required fields are:</p>
                                <ul className='required-list'>
                                    <li>Domain Model file</li>
                                    <li>General :- Model Name</li>
                                    <li>General :- Model Language</li>
                                    <li>Description :- Category</li>
                                </ul>
                            </>
                        )}
                        <button onClick={handlePopupClose}>OK</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PublishDomain;
